var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-combobox',{attrs:{"value":_vm.value,"items":_vm.columns,"outlined":"","dense":"","hide-details":"","label":_vm.label},on:{"input":function($event){return _vm.$emit('input', $event || '')},"change":function($event){return _vm.$emit('input', $event || '')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }